import { zodResolver } from '@hookform/resolvers/zod'
import { cn } from '@repo/tailwind-config/tailwind.functions'
import { AvailableLanguages } from '@repo/toolkit/language-types'
import { TFunction } from 'i18next'
import { useForm } from 'react-hook-form'
import { z, ZodType } from 'zod'

import useTranslate from '../../../../lib/hooks/use-translate'
import { MissionToExternalStaffInput } from '../../../../lib/types/models/mission-to-external-staff/mission-to-external-staff-input'
import { BaseFormProps } from '../../../../lib/types/utils'
import { getSubmitAction } from '../../../../lib/utils/buttons-config/validation-buttons-config'
import { PHONE_NUMBER_SCHEMA } from '../../../../lib/utils/validations/phone-number.validation'
import { createStringSchema } from '../../../../lib/utils/validations/string-validation'
import { FORM_MODE } from '../../../../utils/constants/form.constants'
import Form, { FormControl, FormField, FormItem } from '../../../elements/forms/form'
import ControlledInput from '../../../elements/inputs/controlled-input'
import ControlledPhoneInput from '../../../elements/inputs/controlled-phone-input'
import ValidationButtons from '../../../elements/validation-buttons'

type Props = BaseFormProps<MissionToExternalStaffInput> & {
  className?: string
}

const formSchema: (
  t: TFunction<AvailableLanguages, undefined>
) => ZodType<MissionToExternalStaffInput> = (t) =>
  z.object({
    firstName: createStringSchema('Prénom'),
    lastName: createStringSchema('NOM'),
    email: createStringSchema('Email', { isEmail: true }),
    phone: PHONE_NUMBER_SCHEMA(t)
  })

const ExternalStaffForm = ({ className, defaultValues, ...validationButtonProps }: Props) => {
  const { t } = useTranslate()
  const form = useForm<MissionToExternalStaffInput>({
    resolver: zodResolver(formSchema(t)),
    defaultValues,
    mode: FORM_MODE
  })

  return (
    <Form form={form}>
      <form onSubmit={form.handleSubmit(getSubmitAction(validationButtonProps.buttonsConfig))}>
        <div className={cn('grid grid-cols-2 gap-3', className)}>
          <FormField
            control={form.control}
            name="lastName"
            render={({ field }) => (
              <FormItem className="flex-1">
                <FormControl>
                  <ControlledInput required {...field} label="NOM" type="text" />
                </FormControl>
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="firstName"
            render={({ field }) => (
              <FormItem className="flex-1">
                <FormControl>
                  <ControlledInput required {...field} label="Prénom" type="text" />
                </FormControl>
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="email"
            render={({ field }) => (
              <FormItem className="flex-1">
                <FormControl>
                  <ControlledInput required {...field} label="Email" type="email" />
                </FormControl>
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="phone"
            render={({ field }) => (
              <FormItem className="flex-1">
                <FormControl>
                  <ControlledPhoneInput required {...field} defaultCountry="FR" />
                </FormControl>
              </FormItem>
            )}
          />
        </div>

        <ValidationButtons {...validationButtonProps} hasBorderTop />
      </form>
    </Form>
  )
}

export default ExternalStaffForm
